export default {
  namespaced: true,
  state: {
    modalVisible: false,
    modalComponent: null,
    modalData: null
  },
  getters: {},
  mutations: {
    showModal(state, payload) {
      state.modalVisible = true
      state.modalComponent = payload.component
      state.modalData = payload.data
    },
    hideModal(state) {
      state.modalVisible = false
    }
  },
  actions: {}
}
